export default class GetUserProfile {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  async execute(uid) {
    try {
      // Récupérer le profil de l'utilisateur
      const user = await this.userRepository.getUser(uid);
      
      // Essayer de récupérer les préférences utilisateur
      try {
        // Récupérer les préférences directement depuis Firestore
        const preferences = await this.userRepository.getUserPreferences(uid);
        
        // Ajouter les préférences à l'objet utilisateur
        if (preferences) {
          // Si Firestore a des préférences, utiliser celles-ci
          user.preferences = preferences;
        } else {
          // Définir des préférences par défaut si aucune n'est trouvée dans Firestore
          user.preferences = {
            profileVisibility: 'everyone', // La valeur par défaut reste 'everyone'
            theme: 'system',
            language: 'fr'
          };
        }
      } catch (prefError) {
        console.error("GetUserProfile - Error loading preferences:", prefError);
        // En cas d'erreur, définir des préférences par défaut
        user.preferences = {
          profileVisibility: 'everyone',
          theme: 'system',
          language: 'fr'
        };
      }
      
      return user;
    } catch (error) {
      console.error("GetUserProfile - Error:", error);
      throw error;
    }
  }
} 